import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_1/BuildingInstructions_Images/MainModels`

const Pic1 = `${FullPath}/PortableSkyWheelRide/1_1x.png`;
const Pic2 = `${FullPath}/PortableSkyWheelRide/2_1x.png`;
const Pic3 = `${FullPath}/PortableSkyWheelRide/3_1x.png`;
const Pic4 = `${FullPath}/PortableSkyWheelRide/4_1x.png`;
const Pic5 = `${FullPath}/PortableSkyWheelRide/5_1x.png`;
const Pic6 = `${FullPath}/PortableSkyWheelRide/6_1x.png`;
const Pic7 = `${FullPath}/PortableSkyWheelRide/7_1x.png`;
const Pic8 = `${FullPath}/PortableSkyWheelRide/8_1x.png`;
const Pic9 = `${FullPath}/PortableSkyWheelRide/9_1x.png`;
const Pic10 = `${FullPath}/PortableSkyWheelRide/10_1x.png`;
const Pic11 = `${FullPath}/PortableSkyWheelRide/11_1x.png`;
const Pic12 = `${FullPath}/PortableSkyWheelRide/12_1x.png`;
const Pic13 = `${FullPath}/PortableSkyWheelRide/13_1x.png`;
const Pic14 = `${FullPath}/PortableSkyWheelRide/14_1x.png`;
const Pic15 = `${FullPath}/PortableSkyWheelRide/15_1x.png`;
const Pic16 = `${FullPath}/PortableSkyWheelRide/16_1x.png`;
const Pic17 = `${FullPath}/PortableSkyWheelRide/17_1x.png`;
const Pic18 = `${FullPath}/PortableSkyWheelRide/18_1x.png`;
const Pic19 = `${FullPath}/PortableSkyWheelRide/19_1x.png`;




export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
        Pic12,
        Pic13,
        Pic14,
        Pic15,
        Pic16,
        Pic17,
        Pic18,
        Pic19,
    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}